<template>
	<el-container class="box"> 
		<div class="headerCom"> 
          <publicBreadCrumb  :breadList="breadList"/> 
        </div>
		<el-main class="content-box">
			<el-form v-if="edit" :key="100" :model="orgFormData" :rules="rules" ref="ruleForm" label-width="150px">
				<div>
					<el-row>
						<el-col :span="24">
							<span class="tag">基本信息</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="机构名称：" prop="name">
								<el-input v-model="orgFormData.name" size="medium" clearable maxlength="30"
									placeholder="请输入机构名称"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="机构简称：" prop="shortName">
								<el-input v-model="orgFormData.shortName" size="medium" clearable placeholder="请输入机构简称">
								</el-input>
							</el-form-item>
						</el-col>

					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="机构类型：" prop="orgType">
								<el-select v-model="orgFormData.orgType" style="width:100%" clearable filterable
									size="medium" placeholder="请选择类型">
									<el-option v-for="item in orgTypeList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>

						<el-col :span="12" style="display:flex">
							<el-form-item label="等级：" prop="level">
								<el-select v-model="orgFormData.level" clearable filterable size="medium"
									placeholder="请选择级别分类">
									<el-option v-for="item in levelList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label-width="0" prop="grade">
								<el-select v-model="orgFormData.grade" style="margin-left:4%" clearable filterable
									size="medium" placeholder="请选择等级">
									<el-option v-for="item in gradeList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="业务分类：" prop="businessType">
								<el-select v-model="orgFormData.businessType" style="width:100%" clearable filterable
									size="medium" placeholder="请输入业务分类">
									<el-option v-for="item in businessTypeList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="客服电话：" prop="serverTel">
								<el-input v-model="orgFormData.serverTel" size="medium" clearable placeholder="请输入客服电话">
								</el-input>
							</el-form-item>
						</el-col>

					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="机构银行账户：" prop="orgBankAccount">
								<el-input v-model="orgFormData.orgBankAccount" maxlength="30"
									@blur="checkBanck(orgFormData.orgBankAccount,1)" size="medium" clearable
									placeholder="请输入机构银行账户">
									<template
										slot="append">{{orgFormData.orgBankName?orgFormData.orgBankName:`显示开户行名称${orgFormData.orgBankAccount?'(未查到)':''}`}}</template>
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="机构地址：" prop="address" style="position: relative;">
								<el-input disabled v-model="orgFormData.address" size="medium" clearable
									placeholder="请选择机构地址">
								</el-input>
								<el-button style="position: absolute;right: 10px;" type="text" @click="choiseAddress">
									选择地址</el-button>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="营业执照：" prop="businessLicenseList">
								<el-upload class="upload-demo" action="/api/dsicm-contact-platform/feign/file/upload"
									:data="{ path: 'dsicm-doctor'}" :before-upload="beforeAvatarUpload1" :limit="5"
									:on-remove="handleRemove" :on-success="handleChange1"
									:file-list="orgFormData.businessLicenseList">
									<el-button size="small" type="primary">点击上传</el-button>
								</el-upload>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="上传logo：" prop="imageUrlRes">
								<BaseUploadFile  message="*请上传600*600px的图片" :data="{ path: 'dsicm-doctor', type: 'image',
								  mediaId: orgFormData.mediaId || '' ,appId: orgFormData.wxPublicId}" :multiple="false" :fileSize="6" :isShowTip="false"
									:size="60" :height="60" :headers="headers" :handleBeforeUpload="beforeAvatarUpload"
									action="/api/dsicm-contact-platform/feign/file/upload" :beforeRemove="handleRemove1" :responseFn="handleChange"
									v-model="orgFormData.imageUrlRes">								
								</BaseUploadFile>
								
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="24">
							<el-form-item label="机构简介：" prop="description">
								<el-input type="textarea" clearable size="medium" :autosize="{ minRows: 2, maxRows: 6 }"
									maxlength="100" placeholder="请输入机构简介(最多输入100字)" v-model="orgFormData.description">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<!-- <el-row>
						<el-col :span="24">
							<span class="tag">机构配置</span>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="登录名称：" prop="loginUsername">
								<el-input clearable :disabled="!!type" size="medium" maxlength="30" placeholder="请输入登录名称"
									v-model="orgFormData.loginUsername">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="手机号：" prop="loginPhone">
								<el-input clearable :disabled="!!type" size="medium" placeholder="请输入登录名称"
									v-model="orgFormData.loginPhone">
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="负责人：" prop="orgPrincipal">
								<el-input clearable :disabled="!!type" size="medium" maxlength="30" placeholder="请输入负责人"
									v-model="orgFormData.orgPrincipal">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="关联平台：" prop="platformId">
								<el-select :disabled="!orgFormData.isModify && !!type" v-model="orgFormData.platformId"
									style="width:100%" clearable filterable size="medium" placeholder="请选择类型">
									<el-option v-for="item in platformList" :key="item.id" :label="item.name"
										:value="item.id">
									</el-option>
								</el-select>

							</el-form-item>
						</el-col>
					</el-row>


					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="微信公众号：" prop="wxPublicId">
								<el-select :disabled="!orgFormData.isModify && !!type" v-model="orgFormData.wxPublicId"
									style="width:100%" clearable filterable size="medium" placeholder="请选择微信公众号">
									<el-option :label="sub.name" :value="sub.appId"
										v-for="(sub, subIndex) in wxPublicList" :key="subIndex"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="入驻开始时间：" prop="enterStartTime">
								<el-date-picker style="width: 100%;" value-format="yyyy-MM-dd" placeholder="请选择入驻开始时间"
									v-model="orgFormData.enterStartTime" clearable align="center"
									popper-class="popper-class" type="date">
								</el-date-picker>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="入驻截止时间：" prop="enterEndTime">
								<el-date-picker style="width: 100%;" value-format="yyyy-MM-dd" placeholder="请选择入驻结束时间"
									v-model="orgFormData.enterEndTime" clearable align="center"
									popper-class="popper-class" type="date">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="是否启用号码保护：" prop="isNumberProtect">
								<el-radio-group v-model="orgFormData.isNumberProtect">
									<el-radio :label="true">启用</el-radio>
									<el-radio :label="false">停用</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="机构服务：" prop="orgServerType">
								<el-checkbox-group v-model="orgFormData.orgServerType">
									<el-checkbox :label="1">全病程管理</el-checkbox>
									<el-checkbox :label="2">上门护理</el-checkbox>
								</el-checkbox-group>
							</el-form-item>
						</el-col>

					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="状态：" prop="disabled">
								<el-radio-group v-model="orgFormData.disabled">
									<el-radio :label="false">启用</el-radio>
									<el-radio :label="true">停用</el-radio>
								</el-radio-group>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="服务范围：" prop="orgServerRange" style="position: relative;">
								<el-input v-model="orgFormData.orgServerRange" size="medium" clearable
									placeholder="请输入服务范围">
								</el-input>
								<span style="position: absolute;right: 10px;">km</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<span class="tag">运营信息</span>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="合同签署时间：" prop="signTime">
								<el-date-picker value-format="yyyy-MM-dd" style="width: 100%;" placeholder="请选择签署时间"
									v-model="orgFormData.signTime" clearable align="center" popper-class="popper-class"
									type="date">
								</el-date-picker>
							</el-form-item>
						</el-col>

					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="销售负责人姓名：" prop="salesPrincipal">
								<el-input v-model="orgFormData.salesPrincipal" size="medium" clearable
									placeholder="请输入销售负责人姓名">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="所属部门：" prop="salesDepartment">
								<el-input v-model="orgFormData.salesDepartment" maxlength="15" size="medium" clearable
									placeholder="请输入所属部门">
								</el-input>
							</el-form-item>
						</el-col>

					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="银行账户：" prop="salesBankAccount">
								<el-input v-model="orgFormData.salesBankAccount"
									@blur="checkBanck(orgFormData.salesBankAccount,2)" size="medium" clearable
									placeholder="请输入银行账户">
									<template
										slot="append">{{orgFormData.salesBankName?orgFormData.salesBankName:'显示开户行名称'}}</template>
								</el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="运营团队负责人姓名：" label-width="152px" prop="operatePrincipal">
								<el-input v-model="orgFormData.operatePrincipal" size="medium" clearable
									placeholder="请输入运营团队负责人姓名">
								</el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="所属部门：" prop="operateDepartment">
								<el-input v-model="orgFormData.operateDepartment" maxlength="15" size="medium" clearable
									placeholder="请输入所属部门">
								</el-input>
							</el-form-item>

						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<el-form-item label="银行账户：" prop="operateBankAccount">
								<el-input v-model="orgFormData.operateBankAccount"
									@blur="checkBanck(orgFormData.operateBankAccount,3)" size="medium" clearable
									placeholder="请输入银行账户">
									<template
										slot="append">{{orgFormData.operateBankName?orgFormData.operateBankName:'显示开户行名称'}}</template>
								</el-input>
							</el-form-item>
						</el-col>
					</el-row> -->
					<el-row style="padding-top: 10px;">
						<el-col :span="12">
							<el-form-item>
								<el-button size="small" @click="resetHandel">重置</el-button>
								<el-button type="primary" size="small" @click="queryHandel">保存</el-button>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</el-form>
			<el-form v-else :key="101" :model="orgFormData" label-width="150px">
				<div >
					<el-row>
						<el-col :span="24">
							<span class="tag">基本信息</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<el-form-item label="机构名称：" prop="name">
								<span>{{orgFormData.name}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="机构简称：" prop="shortName">
								<span>{{orgFormData.shortName}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="机构类型：" prop="orgType">
								<span>{{orgFormData.orgTypeDisplayAs}}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">


						<el-col :span="8" style="display:flex">
							<el-form-item label="等级：" prop="level">
								<span>{{orgFormData.levelDisplayAs}}</span>
							</el-form-item>
							<el-form-item label-width="0" prop="grade">
								<span>{{orgFormData.gradeDisplayAs}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="业务分类：" prop="businessType">
								<span>{{orgFormData.businessTypeDisplayAs}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="客服电话：" prop="serverTel">
								<span>{{orgFormData.serverTel}}</span>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="8">
							<el-form-item label="机构银行账户：" prop="orgBankAccount">
								<span>{{orgFormData.orgBankAccount}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="机构地址：" prop="address" style="position: relative;">
								<span>{{orgFormData.address}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="营业执照：" prop="businessLicenseList">
								<!-- <el-upload
									class="upload-demo"
									action="/api/dsicm-contact-platform/feign/file/upload"
									:data="{ path: 'dsicm-doctor'}"
									disabled
									multiple
									:limit="5"
									:on-remove="handleRemove"
									:on-success="handleChange1"
									:file-list="orgFormData.businessLicenseList">
									<el-button size="small" type="primary">点击上传</el-button>
								</el-upload> -->
								<p v-if="orgFormData.businessLicenseList==null||!orgFormData.businessLicenseList.length">暂无数据</p>
								<p v-for="item in orgFormData.businessLicenseList" :key="item.id">
									<i class="el-icon-document"></i>
									{{item.pdfName}}
								</p>
								
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>

						<el-col :span="8">
							<el-form-item label="上传logo：" prop="imageUrlRes">
								<!-- <el-upload
								  class="avatar-uploader avatar-pic"
								  action="/api/dsicm-contact-platform/feign/file/wechat/upload/app-id"
								  :before-upload="beforeAvatarUpload"
								  :headers="headers"
								  :data="{ path: 'dsicm-doctor', type: 'image',
								  mediaId: orgFormData.mediaId || '' ,appId: orgFormData.wxPublicId}"
								  :show-file-list="false"
								  :on-success="handleChange"> -->
								<img v-if="orgFormData.imageUrl" :src="orgFormData.imageUrlRes" class="avatar">
								<!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
								<span v-else>暂无数据</span>
								<!-- </el-upload> -->
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="机构简介：" prop="description">
								<!-- <span>{{orgFormData.description}}</span> -->
								<el-tooltip :content="orgFormData.description"
									:disabled="orgFormData.description && orgFormData.description.length>8?false:true"
									placement="top">
									<span class="fieldWidth">{{ orgFormData.description|filterValgang }}</span>
								</el-tooltip>
							</el-form-item>
						</el-col>
					</el-row>

					<!-- <el-row>
						<el-col :span="24">
							<span class="tag">机构配置</span>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="登录名称：" prop="loginUsername">
								<span>{{orgFormData.loginUsername}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="手机号：" prop="loginPhone">
								<span>{{orgFormData.loginPhone}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="负责人：" prop="orgPrincipal">
								<span>{{orgFormData.orgPrincipal}}</span>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="20">

						<el-col :span="8">
							<el-form-item label="关联平台：" prop="platformId">
								<span>{{orgFormData.platformName}}</span>

							</el-form-item>
						</el-col>

						<el-col :span="8">
							<el-form-item label="微信公众号：" prop="wxPublicId">
								<span>{{orgFormData.wxPublicName}}</span>
							</el-form-item>
						</el-col>

					</el-row>


					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="入驻开始时间：" prop="enterStartTime">
								<span>{{orgFormData.enterStartTime}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="入驻截止时间：" prop="enterEndTime">
								<span>{{orgFormData.enterEndTime}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="是否启用号码保护：" prop="isNumberProtect">
								<span>{{orgFormData.isNumberProtect?'是':"否"}}</span>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">

						<el-col :span="8">
							<el-form-item label="机构服务：" prop="orgServerType">
								<span>{{orgFormData.orgServerType1==1?'全病程管理':orgFormData.orgServerType1==2?'上门护理':'全病程管理, 上门护理'}}</span>
								
							</el-form-item>
						</el-col>

						<el-col :span="8">
							<el-form-item label="状态：" prop="disabled">
								<span>{{orgFormData.disabled?'禁用':'启用'}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="服务范围：" prop="orgServerRange">

								<span>{{orgFormData.orgServerRange}}km</span>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="24">
							<span class="tag">运营信息</span>
						</el-col>
					</el-row>
					<el-row :gutter="20">
						<el-col :span="12">
							<el-form-item label="合同签署时间：" prop="signTime">
								<span>{{orgFormData.signTime | filterValgang}}</span>
							</el-form-item>
						</el-col>

					</el-row>
					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="销售负责人姓名：" prop="salesPrincipal">
								<span>{{orgFormData.salesPrincipal | filterValgang}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="所属部门：" prop="salesDepartment">
								<span>{{orgFormData.salesDepartment | filterValgang}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="银行账户：" prop="salesBankAccount">
								<span>{{orgFormData.salesBankAccount | filterValgang}}</span>

							</el-form-item>
						</el-col>
					</el-row>

					<el-row :gutter="20">
						<el-col :span="8">
							<el-form-item label="运营团队负责人姓名：" label-width="152px" prop="operatePrincipal">
								<span>{{orgFormData.operatePrincipal | filterValgang}}</span>
							</el-form-item>
						</el-col>
						<el-col :span="8">
							<el-form-item label="所属部门：" prop="operateDepartment">
								<span>{{orgFormData.operateDepartment | filterValgang}}</span>
							</el-form-item>

						</el-col>
						<el-col :span="8">
							<el-form-item label="银行账户：" prop="operateBankAccount">
								<span>{{orgFormData.operateBankAccount | filterValgang }}</span>
							</el-form-item>
						</el-col>
					</el-row> -->

					<el-row style="padding-top: 10px;">
						<el-col :span="12">
							<el-form-item>
								<el-button type="primary" @click="edit=true">编辑</el-button>
							</el-form-item>
						</el-col>
					</el-row>
				</div>
			</el-form>
		</el-main>

		<el-dialog title="选择位置" :visible.sync="dialogVisible" v-if="dialogVisible" width="600px">
			<AMapDialog :longitude="orgFormData.longitude" :latitude="orgFormData.latitude" @addressCallback="addressCallback"></AMapDialog>
			<span slot="footer" class="dialog-footer">
				<!-- <el-button @click="">取 消</el-button> -->
				<el-button type="primary" size="small" @click="surePlace">确 定</el-button>
			</span>
		</el-dialog>
	</el-container>
</template>

<script>
	import {
		platformList,
		checkBankCard,
		getHospitalById
	} from './api';
	import {
		addhospital,
		puthospital,
		addPlatform,
		putPlatform,
		codechildren,
		wechatPlatform,
		getHospital,
		getSupervisionList
	} from '@/api/org.js';

	import local from '@/utils/local.js';
	import AMapDialog from "@/components/AMap/AMapDialog.vue";
	export default {
		components: {
			AMapDialog,
		},
		data() {
			var checkTel = (rule, value, callback) => {
				if (!value) {
				  return callback(new Error('此项为必填项'));
				}
				setTimeout(() => {
				  // if (!Number.isInteger(value)) {
				  //   callback(new Error('请输入数字值'));
				  // } else {
				  var phonereg = /[0-9][-/_]{1,30}/
				  var phonereg1 = /^\d{1,30}$/
				  if (!phonereg.test(value) && !phonereg1.test(value)) {
						
					  callback(new Error('请按要求填写'));
					} else {
					  callback();
					}
				  // }
				}, 1000);
			  };
			return {
				breadList:[{name:'机构组织'},{name:'机构信息'}],
				edit: false,
				type: "",
				dialogVisible: false,
				orgFormData: {
					companyId: "",
					name: "",
					shortName: "",
					orgType: "",
					level: "",
					grade: "",
					businessType: "",
					serverTel: "",
					orgBankAccount: "",
					orgBankName: "",
					address: "",
					businessLicenseList: [],
					imageUrl: "",
					description: "",
					loginUsername: '',
					loginPhone: "",
					orgPrincipal: "",
					platformId: "",
					wxPublicId: "",
					wxPublicName: "",
					enterStartTime: "",
					enterEndTime: "",
					isNumberProtect: true,
					orgServerType: [],
					disabled: false,
					orgServerRange: "",
					signTime: "",
					salesPrincipal: "",
					salesDepartment: "",
					salesBankAccount: "",
					salesBankName: "",
					operatePrincipal: "",
					operateDepartment: "",
					operateBankAccount: "",
					operateBankName: "",
					mediaId: "",
					longitude: '',
					latitude: "",
					district:""
				},
				rules: {
					// imageUrlRes:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur']}],
					name: [{
							required: true,
							message: '此项为必填项',
							trigger: ['change', 'blur']
						},
						{
							min: 1,
							max: 30,
							message: '长度在 1 到 30 个字符',
							trigger: 'blur'
						}
					],
					shortName: [{
							required: true,
							message: '此项为必填项',
							trigger: ['change', 'blur']
						},
						{
							min: 1,
							max: 30,
							message: '长度在 1 到 30 个字符',
							trigger: 'blur'
						}
					],
					serverTel: [{
						required: true,
						message: '此项为必填项',
						trigger: ['change', 'blur']
					}, {
						validator:checkTel,
						trigger: ['change', 'blur'],
					},],
					orgBankAccount: [{
						required: true,
						message: '此项为必填项',
						trigger: ['change', 'blur']
					}],
					loginUsername: [{
							required: true,
							message: '此项为必填项',
							trigger: ['change', 'blur']
						},
						{
							pattern: /[0-9a-zA-Z]{1,30}/,
							message: '请按要求填写',
							trigger: ['change', 'blur']
						},
					],
					loginPhone: [{
							required: true,
							message: '此项为必填项',
							trigger: ['change', 'blur']
						},
						{
							type: 'number',
							message: '手机号格式不正确',
							trigger: 'blur',
							transform(value) {
								var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/
								if (!phonereg.test(value)) {
									return false
								} else {
									return Number(value)
								}
							}
						}
					],
					orgPrincipal: [{
						required: true,
						message: '此项为必填项',
						trigger: ['change', 'blur']
					}],
					enterStartTime: [{
						required: true,
						message: '请选择入驻开始时间',
						trigger: 'change'
					}],
					enterEndTime: [{
						required: true,
						message: '请选择入驻结束时间',
						trigger: 'change'
					}],
					isNumberProtect: [{
						required: true,
						message: '请选择是否启用号码保护',
						trigger: 'change'
					}],
					orgServerRange: [{
						required: true,
						message: '请选择是否启用号码保护',
						trigger: ['change', 'blur']
					}],
					orgServerType: [{
						type: 'array',
						required: true,
						message: '请选择机构服务',
						trigger: 'change'
					}],
					orgType: [{
						required: true,
						message: '此项为必填项',
						trigger: ['change', 'blur']
					}],
					level: [{
						required: true,
						message: '此项为必填项',
						trigger: ['change', 'blur']
					}],
					grade: [{
						required: true,
						message: '此项为必填项',
						trigger: ['change', 'blur']
					}],
					businessType: [{
						required: true,
						message: '此项为必填项',
						trigger: ['change', 'blur']
					}],
					address: [{
							required: true,
							message: '此项为必填项',
							trigger: ['change', 'blur']
						}
					],
					platformId: [{
						required: true,
						message: '此项为必填项',
						trigger: ['change', 'blur']
					}],
					// category:[{ required: true, message: '此项为必填项', trigger: ['change', 'blur']}],
					disabled: [{
						required: true,
						message: '此项为必填项',
						trigger: ['change', 'blur']
					}],
					wxPublicId: [{
						required: true,
						message: '此项为必填项',
						trigger: ['change', 'blur']
					}],

					hospitalId: [{
						required: true,
						message: '此项为必填项',
						trigger: ['change', 'blur']
					}]
				},
				platformList: [],
				hospitalsList: [],
				platLevelList: [],
				supervisionList: [],
				wxAppletList: [],
				wxPublicList: [],
				levelList: [],
				gradeList: [],
				businessTypeList: [],
				orgTypeList: [],
				ossBaseUrl: process.env.VUE_APP_OSS_URL, //预览图片基础路径
				// orgFormData: {
				//   category: 1
				// },


				// radio2: 3,
				headers: {
					Authorization: localStorage.getItem('Authorization'),
				},
				temp: {
					address: '',
					longitude: "",
					latitude: "",
					district:""
				},
			}
		},
		mounted() {
			// this.type = this.$route.query.type ? this.$route.query.type : '';
			// if (this.type) {
			this.orgFormData.id = this.$store.state.hospitalId || local.get('hospitalId')
			getHospitalById(this.orgFormData.id).then(res => {

				Object.assign(this.orgFormData, res.data)
				if (res.data.businessLicenseList!=null&&res.data.businessLicenseList.length) {
					for (var i = 0; i < res.data.businessLicenseList.length; i++) {
						this.orgFormData.businessLicenseList[i].name = res.data.businessLicenseList[i].pdfName;
					}
				}
				this.orgFormData.imageUrlRes = res.data.imageUrl ? this.ossBaseUrl + res.data.imageUrl : '';
			})
			
			platformList().then(res => {
				this.platformList = res.data;
			})
			this.getHospitalInit();
			this.getcodechildrenList();
			this.getWechatPlatformTwo();
			this.orgFormData.companyId = this.$store.state.companyId || local.get('companyId')
		},
		methods: {
			handleRemove(file, fileList) {
				this.orgFormData.businessLicenseList.splice(this.orgFormData.businessLicenseList.indexOf(file), 1)
			},

			handleChange(file) { 
			  if(file.code==0){ 
				  this.orgFormData.imageUrl = file.data
				//   this.orgFormData.mediaId = file.data.media_id
				//   this.orgFormData.imageUrlRes = this.ossBaseUrl + file.data
				  this.$set(this.orgFormData, 'imageUrlRes', this.ossBaseUrl + file.data) 
				this.$refs.ruleForm.clearValidate('imageUrlRes')
				this.$forceUpdate();
				return this.ossBaseUrl + file.data;
			  }else{
				  this.$message.error(file.message);
			  }
			  
			},
			handleChange1(res, file) {
				// this.orgFormData.imageUrlRes = this.ossBaseUrl + file.data
				//   this.$set(this.orgFormData, 'imageUrlRes', this.ossBaseUrl + file.data.ossUrl)
				//   this.orgFormData.imageUrl = file.data.ossUrl

				this.orgFormData.businessLicenseList.push({
					ossUrl: res.data,
					name: file.name,
					pdfName: file.name
				})
				//   // this.$forceUpdate()
				this.$message.success('上传成功')
				//   this.$refs.ruleForm.clearValidate('imageUrlRes')
			},
			beforeAvatarUpload1() {
				if (this.orgFormData.businessLicenseList.length > 4) {
					this.$message.error('最多上传5涨')
					return false;
				}
			},
			handleRemove1(){
				this.orgFormData.imageUrl = ""
				this.orgFormData.mediaId = ""
				this.$set(this.orgFormData, 'imageUrlRes', "")
				this.$forceUpdate()
			},
			beforeAvatarUpload(file) {
				if (!this.orgFormData.wxPublicId) {
					this.$message.error('请先选择微信公众号')
					return false;
				}
				const isJPG = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg'
				// const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
				const isLt5M = file.size / 1024 / 1024 < 5
				if (!isJPG) {
					this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
				}
				if (!isLt5M) {
					this.$message.error('上传头像图片大小不能超过 5MB!')
				}
				return isJPG && isLt5M
			},
			checkBanck(num, type) {
				if (!num) {
					this.setBankName('')
					return
				}
				checkBankCard(num).then(res => {
					this.setBankName(res.data!=null?res.data.name : '')
				})
			},
			setBankName(value) {
				if (type == 1) {
					this.orgFormData.orgBankName = value;
				}
				if (type == 2) {
					this.orgFormData.salesBankName = value;
				}
				if (type == 3) {
					this.orgFormData.operateBankName = value;
				}
			},
			addressCallback(value) {
				this.temp.address = value.address
				this.temp.district = value.adcode
				this.temp.longitude = value.lnglat[0]
				this.temp.latitude = value.lnglat[1]
			},
			surePlace() {
				if (!(this.temp.longitude && this.temp.latitude && this.temp.address && this.temp.district)) {
					this.$message.info("请选择地址");
					return
				}
				this.orgFormData.district = this.temp.district;
				this.orgFormData.address = this.temp.address;
				this.orgFormData.longitude = this.temp.longitude;
				this.orgFormData.latitude = this.temp.latitude;
				this.dialogVisible = false;
			},
			resetHandel() {
				this.orgFormData.name = "";
				this.orgFormData.shortName = "";
				this.orgFormData.orgType = "";
				this.orgFormData.level = "";
				this.orgFormData.grade = "";
				this.orgFormData.businessType = "";
				this.orgFormData.serverTel = "";
				this.orgFormData.orgBankAccount = "";
				this.orgFormData.orgBankName = "";
				this.orgFormData.address = "";
				this.orgFormData.businessLicenseList = [];
				this.orgFormData.imageUrl = "";
				this.orgFormData.imageUrlRes = '';
				this.orgFormData.description = "";

				this.orgFormData.longitude = '';
				this.orgFormData.latitude = "";

			},
			queryHandel() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						let a = JSON.parse(JSON.stringify(this.orgFormData));
						
						// if (this.type) {
							puthospital(a).then(res => {
								this.$store.dispatch("getUserAuthList", { key: "", search: true });	
								this.$message.success('操作成功');
								getHospitalById(this.orgFormData.id).then(res => {
									this.orgFormData.orgTypeDisplayAs = res.data.orgTypeDisplayAs
									Object.assign(this.orgFormData, res.data)
									if(res.data.businessLicenseList && res.data.businessLicenseList.length){
										for (var i = 0; i < res.data.businessLicenseList.length; i++) {
										
											this.orgFormData.businessLicenseList[i].name = res.data
												.businessLicenseList[i].pdfName;
										}
									}
									
									this.orgFormData.imageUrlRes = res.data
										.imageUrl?this.ossBaseUrl + res.data
										.imageUrl:"";
										this.$forceUpdate();
								})
								this.edit = false;
							})
						// } else {
						// 	addhospital(a).then(res => {
						// 		this.$message.success("操作成功");
						// 		this.type = 1;
						// 		this.edit = true;

						// 	})
						// }


					} else {

						return false;
					}
				})
			},
			choiseAddress() {
				this.dialogVisible = true;
			},
			getHospitalInit() {
				getHospital({
					disabled: false
				}).then((res) => {
					if (res.code == 0) {
						this.hospitalsList = res.data
					}
				})
			},
			getWechatPlatformTwo() {
				wechatPlatform({
					type: 2
				}).then(res => {
					if (res.code == 0) {
						this.wxPublicList = res.data
					}
				})
			},
			/**
			 * @description: 小程序列表
			 * @param {*}
			 * @return {*}
			 */
			getWechatPlatform() {
				wechatPlatform({
					type: 1
				}).then(res => {
					if (res.code == 0) {
						this.wxAppletList = res.data //	小程序列表
					}
				})
			},
			getcodechildrenList() {
				// 医院等级
				codechildren('hospital_new_level').then((res) => {
					if (res.code == 0) {
						this.levelList = res.data
					}
				})
				codechildren('hospital_level').then((res) => {
					if (res.code == 0) {
						this.platLevelList = res.data
					}
				})
				codechildren('hospital_grade').then((res) => {
					if (res.code == 0) {
						this.gradeList = res.data
					}
				})
				// 医院业务类型
				codechildren('hospital_business_type').then((res) => {
					if (res.code == 0) {
						this.businessTypeList = res.data
					}
				})
				// 医院组织类型
				codechildren('hospital_org_type').then((res) => {
					if (res.code == 0) {
						this.orgTypeList = res.data
					}
				})
			},
		}
	}
</script>
<style lang="less" scoped>
	.overflow-style {
		/deep/.el-form-item__content {
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
		}
	}

	/deep/.el-dialog__body {
		max-height: 70vh;
		overflow: auto;
	}

	/deep/.el-dialog__footer {
		padding-bottom: 30px;
	}

	/deep/.el-dialog__body {
		padding: 30px 40px;
		padding-bottom: 0px;
		padding-top: 10px;
	}

	.tag {
		font-size: 14px;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.85);
		margin-bottom: 15px;
		display: flex;
	}

	.tag::before {
		content: '';
		display: block;
		width: 4px;
		height: 15px;
		background: #1A7BFC;
		margin-right: 15px;
		margin-top: 2.5px;
	}

	.hospital-intro {
		/deep/.el-form-item__content {
			line-height: 20px;
			padding-top: 10px;
		}
	}
</style>
<style lang="less">

	.avatar-pic .el-upload {
		border: 1px dashed #d9d9d9;
	}

	.avatar-uploader .el-upload {
		/* border: 1px dashed #d9d9d9; */
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 60px;
		height: 60px;
		line-height: 60px;
		text-align: center;
	}

	.avatar {
		width: 60px;
		height: 60px;
		display: block;
	}

	.message-del-confirm {
		.el-button--primary {
			background-color: #1A7BFC;
		}
	}
</style>
<style scoped lang="less"> 
    .box {
		height: 100%;
		display: flex;
		flex-direction: column;
	}

	.content-box {
		margin: 16px;
		margin-top: 0;
		background: #fff;
		border-radius: 6px;
		padding: 24px;
	}

	.fieldWidth {
		display: inline-block;
		max-width: 200px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
	
</style>
